import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControl,
} from "@mui/material";
import Select from "react-select";
import CustomButton from "src/components/CustomButton";

interface VerifyEventsDialogProps {
  verifyingData: string | null;
  setVerifyingData: React.Dispatch<React.SetStateAction<string | null>>;
  handleVerify: (
    dealId: string,
    status: string,
    reason: string,
    className?: string
  ) => void;
  verifyDataValue: string;
  reason: string;
  setVerifyDataValue: React.Dispatch<React.SetStateAction<string>>;
  setReason: React.Dispatch<React.SetStateAction<string>>;
  label: string;
  className?: string;
  setClassName?: React.Dispatch<React.SetStateAction<string>>;
}

const VerifyDealsDialog = ({
  verifyingData,
  setVerifyingData,
  handleVerify,
  verifyDataValue,
  reason,
  setVerifyDataValue,
  setReason,
  label,
  className,
}: VerifyEventsDialogProps) => {
  return (
    <Dialog
      open={!!verifyingData}
      onClose={() => {
        setVerifyingData(null);
        setVerifyDataValue("");
      }}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        style: {
          height: "400px", // Fixed height
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <DialogTitle>Verify {label}</DialogTitle>
      <DialogContent style={{ flex: 1, overflow: "auto" }}>
        <FormControl fullWidth sx={{ zIndex: "9999", marginBottom: "4px" }}>
          <Select
            value={
              verifyDataValue
                ? { value: verifyDataValue, label: verifyDataValue }
                : null
            }
            placeholder="Select Status"
            onChange={(option) => setVerifyDataValue(option?.value || "")}
            options={[
              { value: "ACTIVE", label: "Active" },
              { value: "PENDING", label: "Pending" },
              { value: "REJECTED", label: "Rejected" },
              { value: "ARCHIVE", label: "Archive" },
            ]}
          />
        </FormControl>

        <TextField
          margin="dense"
          label="Reason"
          fullWidth
          variant="outlined"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          multiline
          rows={4}
        />
      </DialogContent>
      <DialogActions>
        <CustomButton onClick={() => setVerifyingData(null)} variant="outlined">
          Cancel
        </CustomButton>
        <CustomButton
          onClick={() => {
            if (verifyingData && verifyDataValue) {
              handleVerify(verifyingData, verifyDataValue, reason, className);
            }
          }}
          style={{
            color: "#ffffff",
            ...(verifyDataValue && !(verifyDataValue === "REJECTED" && !reason)
              ? {}
              : {
                  backgroundColor: "#cccccc",
                  cursor: "not-allowed",
                  color: "#bbbbbb",
                }),
          }}
          disabled={
            !verifyDataValue || (verifyDataValue === "REJECTED" && !reason)
          }
        >
          Verify
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default VerifyDealsDialog;
